module.exports = "././img/footer.png";


//////////////////
// WEBPACK FOOTER
// ../assets/report-img/qld/footer.png
// module id = 826
// module chunks = 0